// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","logo":"footer_logo__ke--D","header":"footer_header__NpNKk","footerLink":"footer_footerLink__o87rs","link":"footer_link__DsQ78"};